import { render, staticRenderFns } from "./CreateGroupInvitationPopup.vue?vue&type=template&id=4353be74&scoped=true&"
import script from "./CreateGroupInvitationPopup.vue?vue&type=script&lang=js&"
export * from "./CreateGroupInvitationPopup.vue?vue&type=script&lang=js&"
import style0 from "./CreateGroupInvitationPopup.vue?vue&type=style&index=0&id=4353be74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4353be74",
  null
  
)

export default component.exports